import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { ListItem } from '@material-ui/core'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { format } from 'date-fns'
import {
  useGetTaxListingQuery,
  useGetTaxSchemeNewListingQuery,
  useGetTaxSchemeTypeListingQuery,
} from 'generated/graphql'
import React, { useState } from 'react'
import { useHistory, useParams } from 'react-router'

export const TaxSchemeDetails = (props: any) => {
  let history = useHistory()
  const { TaxSchemeID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  const {
    loading: TaxSchemeLoading,
    data: { getTaxSchemeListing } = { getTaxSchemeListing: [] },
  } = useGetTaxSchemeNewListingQuery({
    fetchPolicy: 'network-only',
    variables: { TaxSchemeID },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: TaxListingLoading,
    data: { getTaxListing } = {
      getTaxListing: [],
    },
  } = useGetTaxListingQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: TaxSchemeTypeLoading,
    data: { getTaxSchemeTypeListing } = {
      getTaxSchemeTypeListing: [],
    },
  } = useGetTaxSchemeTypeListingQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const flexRowStyle = {
    display: 'flex' as any,
    flexDirection: 'row' as any,
    justifyContent: 'space-between' as any,
    width: '100%' as any,
  }

  const enumFormatter = (str: string) => {
    return ` ${str
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
      .join(' ')}`
  }

  return (
    <>
      {TaxSchemeLoading && <Loading />}
      {TaxListingLoading && <Loading />}
      {TaxSchemeTypeLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push(`/common-setting/tax-scheme/`)
        }}
        smTitle="Common Settings"
        title={user?.accountName}
        routeSegments={[
          { name: 'General Setting' },
          { name: 'Tax Type' },
          { name: 'Tax Code', current: true },
        ]}
      />
      <ContentWrapper float>
        <CardContents>
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              Name
            </div>
            <div className="mdDesc text-noflow">
              {getTaxSchemeListing[0]?.name}
            </div>
          </div>
          <div className="content-wrap full">
            <div className="desc" style={{ color: 'grey' }}>
              Description
            </div>
            <div className="mdDesc text-noflow" style={{ fontSize: '11px' }}>
              {getTaxSchemeListing[0]?.description}
            </div>
          </div>
        </CardContents>
        <CardContents>
          {getTaxSchemeListing[0]?.taxSchemeDetailList
            ?.sort(
              (a, b) =>
                new Date(a?.effectiveDate).getTime() -
                new Date(b?.effectiveDate).getTime()
            )
            ?.map((el, index) => (
              <ListItem
                style={{
                  padding: '0',
                  display: 'block',
                  borderBottom:
                    index !==
                      getTaxSchemeListing[0]?.taxSchemeDetailList?.length - 1 &&
                    '0.5px solid #212121',
                }}
              >
                <div style={flexRowStyle}>
                  <span className="desc" style={{ alignContent: 'center' }}>
                    {format(new Date(el?.effectiveDate), 'dd MMM yyyy')}
                  </span>
                </div>
                {el?.taxSchemeDetailItemList?.map((inel, inindex) => (
                  <ListItem className="desc" style={{ display: 'block' }}>
                    <div style={flexRowStyle}>
                      <span>
                        {inindex + 1}
                        .&nbsp;
                        {`${
                          getTaxListing?.find(x => x?.tax_id === inel?.taxId)
                            ?.code
                        } ${
                          getTaxListing?.find(x => x?.tax_id === inel?.taxId)
                            ?.rate
                        }%`}
                      </span>
                      <span>
                        {
                          getTaxSchemeTypeListing?.find(
                            x =>
                              x?.id ===
                              getTaxListing?.find(
                                x => x?.tax_id === inel?.taxId
                              )?.scheme_type_id
                          )?.name
                        }
                      </span>
                    </div>
                    <div style={flexRowStyle}>
                      <span>{`${enumFormatter(inel?.computeMethod)}`}</span>
                      <span>
                        {
                          getTaxListing?.find(x => x?.tax_id === inel?.taxId)
                            ?.class_type
                        }
                      </span>
                    </div>
                    <div style={flexRowStyle}>
                      <span>
                        {`${getTaxListing?.find(x => x?.tax_id === inel?.taxId)
                          ?.MasterCOA?.Code ?? 'N/A'} || ${getTaxListing?.find(
                          x => x?.tax_id === inel?.taxId
                        )?.MasterCOA?.Name ?? 'N/A'}`}
                      </span>
                      <span></span>
                    </div>
                  </ListItem>
                ))}
              </ListItem>
            ))}
        </CardContents>
      </ContentWrapper>
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
